import { Component, Inject, Input, OnInit } from '@angular/core';
import { ExaminerSlotSelection } from '../../models/examiner-slot-selection.model';
import { CheckRideRequestEntityExt } from '../../../../meta-data/extensions/check-ride-request-entity.model';
import { AirportWithAddressInfoQueryEntity, AppMetaDataLookups } from '../../../../meta-data/app-meta-data.service';
import { CheckrideRefItem } from '../../models/checkride-ref-item.model';
import { DwMetaDataService, DwMetaDataServiceToken, DwRoutingService } from '@devwareapps/devware-cap';

@Component({
  selector: 'app-examiner-booking-creation-item',
  templateUrl: './examiner-booking-creation-item.component.html',
  styleUrls: ['./examiner-booking-creation-item.component.scss']
})
export class ExaminerBookingCreationItemComponent implements OnInit {
 
  @Input() checkRideRef: CheckrideRefItem;

  checkRideStatusDisplay: string;

  checkrideDateTimeDisplay: string;
  airportInfo: AirportWithAddressInfoQueryEntity;

  constructor(private dwRoutingService: DwRoutingService, @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService) { }

  ngOnInit(): void {

    this.airportInfo = this.checkRideRef.airportInfo;

    const statusId = this.checkRideRef.savingInfo?.savedCheckride?.CheckRideRequestSubStatusId || this.checkRideRef.checkride.CheckRideRequestSubStatusId;

    this.dwMetaDataService.getLookupDisplay(AppMetaDataLookups.CheckRideRequestSubStatusAllItems, statusId)
      .subscribe(status => {
        this.checkRideStatusDisplay = status;
      });
  }

  editCheckride() {
    this.dwRoutingService.navigateToUrl(`/school-checkrides/edit/${this.checkRideRef.checkride.CheckRideRequestId}`, null);
  }
}